"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PRIMARY_CUSTOMER_DATA_REQUESTED = exports.PRIMARY_CUSTOMER_DATA_REQUESTED = "PRIMARY_CUSTOMER_DATA_REQUESTED";
var PRIMARY_CUSTOMER_DATA_RECEIVED = exports.PRIMARY_CUSTOMER_DATA_RECEIVED = "PRIMARY_CUSTOMER_DATA_RECEIVED";
var PRIMARY_CUSTOMER_DATA_REQUEST_FAILED = exports.PRIMARY_CUSTOMER_DATA_REQUEST_FAILED = "PRIMARY_CUSTOMER_DATA_REQUEST_FAILED";

var primaryCustomerDataRequested = exports.primaryCustomerDataRequested = function primaryCustomerDataRequested() {
    return {
        type: PRIMARY_CUSTOMER_DATA_REQUESTED
    };
};

var primaryCustomerDataReceived = exports.primaryCustomerDataReceived = function primaryCustomerDataReceived(primaryCustomerData) {
    return {
        type: PRIMARY_CUSTOMER_DATA_RECEIVED, primaryCustomerData: primaryCustomerData
    };
};

var primaryCustomerDataRequestFailed = exports.primaryCustomerDataRequestFailed = function primaryCustomerDataRequestFailed(error) {
    return {
        type: PRIMARY_CUSTOMER_DATA_REQUEST_FAILED, error: error
    };
};


//////////////////
// WEBPACK FOOTER
// ./app/actions/primaryCustomerDataActions.js
// module id = 203
// module chunks = 0